import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  SmartActionLostCosts,
  SmartActionsGuard,
} from "@/features/office/smart-actions";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const lostCostsSearchSchema = z.object({
  filters: z
    .object({
      ownerUserIds: withOperators(commaListSchema),
      managerUserIds: withOperators(commaListSchema),
      // The notification inbox in the office sidebar writes these on any route.
      ...notificationSearchFragment,
    })
    .optional(),
  ...filterSearchFragment,
  ...maskSearchFragment,
});

export const routeId = "/office/smart-actions/lost-costs";

export const Route = createFileRoute("/office/smart-actions/lost-costs")({
  validateSearch: lostCostsSearchSchema,
  component: SmartActionLostCostsRoute,
});

/** Behind the same gate and role as the board, deep link included. */
function SmartActionLostCostsRoute() {
  return (
    <SmartActionsGuard>
      <SmartActionLostCosts />
    </SmartActionsGuard>
  );
}
